import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import errorImage from '../../assets/img/Union.svg';
import styles from './kbaAuthRetry.module.css';
import { fetchWrapper } from '../../_helpers';
import { alertActions, authActions } from '../../_store';
import { decrypt } from '../../_helpers/encrypt_decrypt';
import ErrorMessage from '../../_components/errorMessage/errorMessage';

export { KbaAuthRetry };

function KbaAuthRetry() {
    // DEFAULTS
    const baseUrl = `${process.env.REACT_APP_API_URL}`;
    const navigate = useNavigate();
    const splideRef = useRef(null);
    const dispatch = useDispatch();

    // STATE
    const [showError, setShowError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [questionsData, setQuestionsData] = useState(null);
    const [reachedEnd, setReachedEnd] = useState(false);
    const [answersData, setAnswersData] = useState(null);
    const [validateBodyRes, setValidateBodyRes] = useState(null);
    const [authSuccess, setAuthSuccess] = useState(false);
    const [errorBlocked, setErrorBlocked] = useState(false);
    const [firstAttemptError, setFirstAttemptError] = useState(true);
    const [hasSelectedAnswer, setHasSelectedAnswer] = useState(true);
    const [count, setCount] = useState(0);

    useEffect(() => {
        // Check To See If User Is Valid
        const registrationAuthenticated = localStorage.getItem(
            'registrationAuthenticated'
        );
        if (registrationAuthenticated) {
            // Fetch KBA Questions From API
            const userData = JSON.parse(registrationAuthenticated);
            fetchKBAQuestions(userData[0]);
        } else {
            navigate('/');
        }
    }, []);

    // *** API Call For Fetching Questions
    const fetchKBAQuestions = async ({ IdNumber }) => {
        setLoading(true);
        setQuestionsData(null);
        setValidateBodyRes(null);
        setReachedEnd(false);
        setAuthSuccess(false);
        setErrorBlocked(false);
        setCount(0);

        try {
            const response = await fetchWrapper.get(
                `${baseUrl}/xds-services/initiate-kba/${IdNumber}`
            );

            setLoading(false);

            const questions =
                response.questions.CurrentObjectState.AuthenticationDocument
                    .Questions;

            if (questions === undefined || questions === null) {
                setErrorBlocked(true);
            } else {
                setQuestionsData(
                    response.questions.CurrentObjectState.AuthenticationDocument
                        .Questions.QuestionDocument
                );
                setValidateBodyRes(response);
            }
        } catch (error) {
            setLoading(false);
            setShowError(true);
        }
    };

    const handleChangeAnswer = (answer_id, question_id) => {
        // *** Excutable Steps ***
        // Get the question ID
        // Get the answer ID
        // Loop thorugh the list of questions then match the question Id that you have
        // Get the answers object
        // Get the answersDocument array from the answers object
        // loop though the answersDocument array
        // Match the AnswersID in the answersDocument array with the one on input change
        // Change value to 'true'
        // Else if not matching change value to 'false'
        setShowError(false);
        setFirstAttemptError(false);
        let changedData = null;
        setAnswersData(null);

        changedData = questionsData;

        changedData.forEach((item, i) => {
            if (item.ProductAuthenticationQuestionID === question_id) {
                item.Answers.AnswerDocument.forEach((answer, j) => {
                    if (answer.AnswerID === answer_id) {
                        changedData[i].Answers.AnswerDocument[
                            j
                        ].IsEnteredAnswerYN = 'true';
                    } else {
                        changedData[i].Answers.AnswerDocument[
                            j
                        ].IsEnteredAnswerYN = 'false';
                    }
                });
            }
        });

        setAnswersData(changedData);
        setHasSelectedAnswer(false);
    };

    const handleSubmitAnswer = async () => {
        if (answersData) {
            setLoadingSubmit(true);
            const requestBody = {
                ...validateBodyRes,
            };

            requestBody.questions.CurrentObjectState.AuthenticationDocument.Questions.QuestionDocument =
                answersData;

            try {
                const response = await fetchWrapper.post(
                    `${baseUrl}/auth/validate-answers`,
                    {
                        requestBody,
                        email: localStorage.getItem('email'),
                    }
                );

                setLoadingSubmit(false);
                const authenticated =
                    response.CurrentObjectState.AuthenticationDocument
                        .AuthenticationStatusInd;

                if (authenticated === 'A') {
                    setAuthSuccess(true);
                    const registeredUser = JSON.parse(
                        localStorage.getItem('registeredUser')
                    );

                    if (registeredUser) {
                        const username = registeredUser.username;
                        const password = decrypt(registeredUser.password);

                        try {
                            const response = await fetchWrapper.post(
                                `${baseUrl}/auth/login`,
                                {
                                    username,
                                    password,
                                }
                            );

                            const newAppUrl = `${process.env.REACT_APP_REDIRECT_URL}?session_state=${response.session}&initial=true`;

                            window.location.href = newAppUrl;
                        } catch (error) {
                            navigate('/login');
                        }
                    }
                } else {
                    setAuthSuccess(false);
                    setShowError(true);
                }
            } catch (error) {
                dispatch(alertActions.error(error));
                setLoadingSubmit(false);
            }
        }
    };

    const renderQuestions = () => {
        if (!questionsData || questionsData.length <= 0) {
            return null;
        }

        return (
            <Splide
                options={{
                    gap: '1rem',
                    arrows: false,
                    rewind: false,
                    drag: false,
                    pagination: false,
                }}
                aria-label='My Favorite Images'
                ref={splideRef}
            >
                {questionsData.map((item, index) => {
                    return (
                        <SplideSlide>
                            <div className={styles.kbaQuestionBasedText}>
                                <p>{item.Question}</p>
                            </div>
                            <div className={styles.kbaRadioInputsContainer}>
                                {item.Answers.AnswerDocument.map(
                                    (answer, jindex) => {
                                        return (
                                            <>
                                                <div
                                                    className={
                                                        styles.kbaRadioInputs
                                                    }
                                                >
                                                    <input
                                                        type='radio'
                                                        id={`answer_${jindex}_${index}`}
                                                        name={`validate_${index}`}
                                                        value={answer.AnswerID}
                                                        onChange={() => {
                                                            handleChangeAnswer(
                                                                answer.AnswerID,
                                                                item.ProductAuthenticationQuestionID
                                                            );
                                                        }}
                                                    />
                                                    <label
                                                        htmlFor={`answer_${jindex}_${index}`}
                                                    >
                                                        {answer.Answer}
                                                    </label>
                                                </div>
                                            </>
                                        );
                                    }
                                )}
                            </div>
                        </SplideSlide>
                    );
                })}
            </Splide>
        );
    };

    const nextQuestion = () => {
        if (count < questionsData.length - 1) {
            splideRef.current.go(count + 1);
            setCount(count + 1);
            setHasSelectedAnswer(true);
        }
    };

    useEffect(() => {
        if (
            questionsData !== null &&
            questionsData !== undefined &&
            questionsData.length > 0 &&
            count === questionsData.length - 1
        ) {
            setReachedEnd(true);
        }
    }, [count]);

    return (
        <div className='card px-md-5 pb-5 py-md-5'>
            <div className={`card-body ${styles.cardBodyCustom}`}>
                <h2 className={styles.kbaTitle}>AUTHENTICATION</h2>
                {firstAttemptError ? (
                    <div className={styles.kbaError}>
                        <img src={errorImage} alt='error authentication' />
                        <p>Authentication failed, please try again.</p>
                    </div>
                ) : null}
                {showError ? (
                    <>
                        <div className={styles.kbaError}>
                            <img src={errorImage} alt='error authentication' />
                            <p>You have failed the authentication</p>
                        </div>
                        <div className='mt-5'>
                            <p>
                                Please contact our team on{' '}
                                <a href='mailto:info@splendi.co.za'>
                                    info@splendi.co.za
                                </a>{' '}
                                for assistance
                            </p>
                        </div>
                    </>
                ) : (
                    <>
                        {/* Success Message */}
                        {authSuccess ? (
                            <div className={styles.authSuccess}>
                                <div class='spinner-border' role='status'>
                                    <span class='visually-hidden'>
                                        Loading...
                                    </span>
                                </div>
                                <div>
                                    <p>Authentication Successful!</p>
                                    <p className='mt-3'>
                                        Login in to your dashboad.
                                    </p>
                                </div>
                            </div>
                        ) : null}
                        <p className={styles.kbaKnowledgeBasedText}>
                            Please answer the knowledge-based questions to
                            complete your registration. You have to answer at
                            least four of five questions correctly to create
                            your account.
                        </p>
                        {errorBlocked ? (
                            <div className='mt-3'>
                                <ErrorMessage
                                    message='Number of attempts exceeded.'
                                    contact='Please contact info@xds.co.za for assistance.'
                                    
                                />
                            </div>
                        ) : null}
                        {/* Questions Data */}
                        {loading ? (
                            <div
                                class='spinner-border mt-4 mx-auto'
                                role='status'
                            >
                                <span class='visually-hidden'>Loading...</span>
                            </div>
                        ) : (
                            renderQuestions()
                        )}
                        {loadingSubmit ? (
                            <div
                                class='spinner-border mt-4 mx-auto'
                                role='status'
                            >
                                <span class='visually-hidden'>Loading...</span>
                            </div>
                        ) : null}
                        {/* Submit Button */}
                        {loading === false && errorBlocked === false ? (
                            <button
                                style={{
                                    background: hasSelectedAnswer
                                        ? '#818181'
                                        : '#000000',
                                }}
                                disabled={hasSelectedAnswer}
                                onClick={
                                    reachedEnd
                                        ? handleSubmitAnswer
                                        : nextQuestion
                                }
                                className={styles.kbaSubmit}
                            >
                                {reachedEnd ? 'Submit' : 'Next Question'}
                            </button>
                        ) : null}
                    </>
                )}
            </div>
        </div>
    );
}
